if (!customElements.get('natunora-countdown')) {
  const calendar = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const partsAt = time => Object.fromEntries(calendar.formatToParts(time)
    .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  const nextMidnight = now => {
    const today = partsAt(now);
    const nextDay = Date.UTC(today.year, today.month - 1, today.day + 1);
    const offset = partsAt(nextDay);
    return nextDay - ((offset.hour * 60 + offset.minute) * 60 + offset.second) * 1000;
  };

  customElements.define('natunora-countdown', class extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.digits = ['hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
      if (this.digits.some(element => !element)) return;
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearInterval(this.interval);
        else this.resume();
      }, options);
      window.addEventListener('pagehide', () => clearInterval(this.interval), options);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.resume();
      }, options);
      this.resume();
    }

    resume() {
      clearInterval(this.interval);
      this.tick();
      if (this.endTime > Date.now() && !document.hidden) {
        this.interval = setInterval(() => this.tick(), 1000);
      }
    }

    tick() {
      const now = Date.now();
      this.endTime = nextMidnight(now);
      const remaining = Math.max(0, Math.floor((this.endTime - now) / 1000));
      const values = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.digits.forEach((element, index) => {
        const value = String(values[index]).padStart(2, '0');
        if (element.textContent !== value) element.textContent = value;
      });
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      this.controller?.abort();
    }
  });
}
